import "core-js/modules/es.array.for-each";
import "core-js/modules/web.dom-collections.for-each";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getOilManageTransportList, getOilManageFleetList, getOilManageFleetcarList, getOilManageFleetdriverList, postOilManageTransportCreate } from '@/api/bairun/oilpsiManage'; //  此处请自行替换地址

import { formatTimeToStr } from '@/utils/date';
export default {
  name: 'TransportOrderNo',
  components: {},
  filters: {
    formatDate: function formatDate(time) {
      if (time != null && time !== '') {
        var date = new Date(time);
        return formatTimeToStr(date, 'yyyy-MM-dd hh:mm:ss');
      } else {
        return '';
      }
    }
  },
  data: function data() {
    return {
      dialogVisible: false,
      // Dialog
      loading: true,
      searchInfo: {},
      tableData: [],
      formData: {},
      fleetList: [],
      // 车队列表
      fleetcarList: [],
      // 车辆列表
      fleetdriverList: [],
      // 司机列表
      page: 1,
      pageSize: 10,
      total: 0,
      // 表单验证
      formRules: {
        transportName: [{
          required: true,
          message: '请输入运输单号名称',
          trigger: 'blur'
        }],
        fleetNo: [{
          required: true,
          message: '请选择车队',
          trigger: 'change'
        }],
        carNumber: [{
          required: true,
          message: '请选择车辆',
          trigger: 'change'
        }],
        driverName: [{
          required: true,
          message: '请选择司机',
          trigger: 'change'
        }],
        carryTotalTon: [{
          required: true,
          message: '请输入总吨数',
          trigger: 'blur'
        }]
      }
    };
  },
  created: function created() {
    this.getTableData();
    this.getOilManageFleetLists();
  },
  methods: {
    // 搜索
    onSubmit: function onSubmit() {
      this.getTableData();
    },
    // 创建
    onCreate: function onCreate() {
      this.fleetdriverList = [];
      this.formData = {};
      this.dialogVisible = true;
    },
    // 确定
    dialogClick: function dialogClick() {
      var _this = this;

      this.$refs['rulesForm'].validate(function (valid) {
        if (valid) {
          postOilManageTransportCreate(_this.formData).then(function (res) {
            if (res.code == 0) {
              _this.$message({
                message: '新建成功',
                type: 'success'
              });

              _this.dialogVisible = false;

              _this.getTableData();
            }
          }, function (err) {});
        } else {
          return false;
        }
      });
    },
    // 表单验证
    formVerification: function formVerification() {
      this.$refs['rulesForm'].validate(function (valid) {});
    },
    inputChange: function inputChange() {
      this.$forceUpdate();
    },
    // 获取微信用户审核列表
    getTableData: function getTableData() {
      var _this2 = this;

      var obj = {
        'page': this.page,
        'pageSize': this.pageSize
      };
      getOilManageTransportList(obj).then(function (res) {
        if (res.code == 0) {
          _this2.tableData = res.data.list;
          _this2.total = res.data.total;
          _this2.loading = false;
        }
      }, function (err) {});
    },
    // 获取车队名称
    fleetFilters: function fleetFilters(fleetNo) {
      var str = '';
      this.fleetList.forEach(function (item) {
        if (item.fleetNo == fleetNo) {
          str = item.fleetName;
        }
      });
      return str;
    },
    // 选择车队
    fleetChange: function fleetChange(fleetNo) {
      var obj = {};
      this.fleetList.forEach(function (item) {
        if (item.fleetNo == fleetNo) {
          obj = item;
          return;
        }
      });
      this.getOilManageFleetcarLists(obj.fleetNo);
      this.getOilManageFleetdriverLists(obj.fleetNo);
    },
    // 清空车队
    fleetClear: function fleetClear() {
      this.formData.carNumber = '';
      this.formData.driverName = '';
      this.fleetcarList = [];
      this.fleetdriverList = [];
    },
    // 选择车辆
    fleetcarChange: function fleetcarChange(carNumber) {
      var time = new Date();
      this.formData.transportName = carNumber + ',' + formatTimeToStr(time, 'MM月dd日');
    },
    // 车队列表
    getOilManageFleetLists: function getOilManageFleetLists(fleetNo) {
      var _this3 = this;

      this.fleetList = [];
      var obj = {
        'page': 1,
        'pageSize': 9999,
        'fleetNo': fleetNo
      };
      getOilManageFleetList(obj).then(function (res) {
        if (res.code == 0) {
          _this3.fleetList = res.data.list;
        }
      }, function (err) {});
    },
    // 车辆列表
    getOilManageFleetcarLists: function getOilManageFleetcarLists(fleetNo) {
      var _this4 = this;

      this.fleetcarList = [];
      var obj = {
        'page': 1,
        'pageSize': 9999,
        'fleetNo': fleetNo
      };
      getOilManageFleetcarList(obj).then(function (res) {
        if (res.code == 0) {
          _this4.fleetcarList = res.data.list;
        }
      }, function (err) {});
    },
    // 司机列表
    getOilManageFleetdriverLists: function getOilManageFleetdriverLists(fleetNo) {
      var _this5 = this;

      this.fleetdriverList = [];
      var obj = {
        'page': 1,
        'pageSize': 9999,
        'fleetNo': fleetNo
      };
      getOilManageFleetdriverList(obj).then(function (res) {
        if (res.code == 0) {
          _this5.fleetdriverList = res.data.list;
        }
      }, function (err) {});
    },
    // 分页处理
    handleCurrentChange: function handleCurrentChange(val) {
      this.page = val;
      this.getTableData();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.getTableData();
    }
  }
};